/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import _ from 'lodash';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceContextRoutePageComponent} from '../../common/controller/admin-resource-context-route-page.component';
import {AdminResourceItemRoutePageComponent} from '../../common/controller/admin-resource-item-route-page.component';
import {adminResourceItemRouteResolve} from '../../common/controller/admin-resource-routing';
import {getRoutePageComponent} from '../../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import {ApiKeyResource} from '../../../components/api/resources/resource/api-key.resource';
import {isOAuthConsentRequest, OAUTH_CONSENT_PARAMS} from './api-key-commons';

function oauthConsentParams(params: any): Record<string, any> {
  return {
    app: params.app,
    callback: params.callback,
    code_challenge: params.code_challenge,
    code_challenge_method: params.code_challenge_method,
    redirect_uri: params.redirect_uri,
    state: params.state,
    client_id: params.client_id,
    resource: params.resource
  };
}

export function apiKeyStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
    let rh = adnRouterHelperProvider.$get().createRouterHelper('api-keys.api-key', ApiKeyResource, 'app.adm', 'app/admin');
    const newItem = rh.newItem(OAUTH_CONSENT_PARAMS);
    const defaultNewItemEnter = newItem.onEnter;
    $stateProvider.state(rh.listPath(), rh.list({
      views: {
        'content@app': {
          component: getRoutePageComponent('api-key-route')
        }
      },
      resolve: {
        readOnly: function() {
          const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

          return LocalUserPermissions.isSelfServiceOwn();
        }
      }
    }))
      .state(rh.newItemPath(), Object.assign(newItem, {
        url: '/new?app&callback&code_challenge&code_challenge_method&redirect_uri&state&client_id&resource',
        onEnter: function($transition$: any) {
          const params = $transition$.params('to');
          if (isOAuthConsentRequest(params)) {
            return adnRouterHelper.services.state().target('nude.mcp-authorize', oauthConsentParams(params));
          }
          return defaultNewItemEnter($transition$);
        }
      }))
      .state(rh.itemPath(), rh.modelCommsItem({
        resolve: _.merge({}, adminResourceItemRouteResolve('api-key-edit', 'edit')),
        url: '/api-key/:id?app&callback&code_challenge&code_challenge_method&redirect_uri&state&client_id&resource',
        params: {
          app: null, callback: null,
          code_challenge: null, code_challenge_method: null, redirect_uri: null, state: null, client_id: null, resource: null
        },
        views: {
          'content@app': {
            component: AdminResourceItemRoutePageComponent,
            bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }
          },
          'context@app': {
            component: AdminResourceContextRoutePageComponent
          }
        }
      }, 'ApiKey'));
  }, adnRouterHelper);
}
